module.exports = __webpack_public_path__ + "img/prize-04.aaadc563.png";